import type { ConceptDef } from '../types';

export const numberLineJump: ConceptDef = {
  kind: 'tileMatch',
  id: 'number-line-jump',
  label: 'Number Line Jump',
  category: 'Math',
  description: 'Hear a starting number and a jump; tap where you land.',
  config: {
    promptMode: 'AUDIO',
    tileCount: 4,
    items: [
      { say: 'Start at 2, jump 3 forward.', answer: '5' },
      { say: 'Start at 5, jump 2 back.', answer: '3' },
      { say: 'Start at 4, jump 4 forward.', answer: '8' },
      { say: 'Start at 6, jump 4 back.', answer: '2' },
      { say: 'Start at 1, jump 5 forward.', answer: '6' },
    ],
  },
};
